export const SUGGESTED_ARTWORKS_LIST = 'suggested-artworks';
export const getArtStreamListForQuery = (query: string) =>
  `artworks-by-query-${query}`;
